
import 
  React, 
  { Component } 
from 'react';
import moment 
  from "moment";
import 
  DateRangePicker 
from 'react-bootstrap-daterangepicker';

// css
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';

// custom
import { 
  IsEmpty 
} from "../Helpers/FormatHelper";

function CustomDatePicker({ component_config, handle_change }) {
  component_config = component_config == null ? { } : component_config;
  
  const startDateParamName = IsEmpty(component_config.start_date_param_name) 
      ? "from" 
      : component_config.start_date_param;
  const endDateParamName = IsEmpty(component_config.end_date_param_name) 
      ? "to" 
      : component_config.end_date_param;
  
  const handleDateChange = (event, picker) => {
    const start = picker.startDate 
        ? moment(picker.startDate._d).format("MM/DD/YYYY") 
        : null;
    handle_change({ 
        [startDateParamName]: start
    });
  }

  const handleDateRangeChange = (event, picker) => {
    const start = picker.startDate 
        ? moment(picker.startDate._d).format("MM/DD/YYYY") 
        : null;
    const end = picker 
        ? moment(picker.endDate._d).format("MM/DD/YYYY") 
        : null;
    handle_change({ 
        [startDateParamName]: start,
        [endDateParamName]: end
    });
  };

  return (
    <>
      { !component_config.date_range &&
          <DateRangePicker 
              initialSettings={{
                singleDatePicker: true
              }} 
              onApply={ handleDateChange }>
            <input type="text" className="form-control w-50" />
          </DateRangePicker>
      }
      { component_config.date_range &&
          <DateRangePicker onApply={ handleDateRangeChange }>
            <input type="text" className="form-control w-50" />
          </DateRangePicker>
      }
    </>
  );
}

export default CustomDatePicker;